import { sdkFactory as wixBadgesV4Badge_sdkFactory_badgesV4 } from './src/badges-v4-badge.frontend';
import { sdkFactory as wixMembersUsermembersV1UserMember_sdkFactory_userMember } from './src/members-usermembers-v1-user-member.frontend';
import { sdkFactory as wixMembersV1CustomField_sdkFactory_customField } from './src/members-v1-custom-field.frontend';
import { sdkFactory as wixMembersV1CustomFieldSuggestion_sdkFactory_customFieldSuggestion } from './src/members-v1-custom-field-suggestion.frontend';
import { sdkFactory as wixMembersV1MemberRoleDefinition_sdkFactory_memberRoleDefinition } from './src/members-v1-member-role-definition.frontend';
import { sdkFactory as wixMembersV1MemberToMemberBlock_sdkFactory_memberToMemberBlock } from './src/members-v1-member-to-member-block.frontend';
// @ts-ignore
export function sdkFactory(args) {
    return {
        badgesV4: wixBadgesV4Badge_sdkFactory_badgesV4(args),
        userMember: wixMembersUsermembersV1UserMember_sdkFactory_userMember(args),
        customField: wixMembersV1CustomField_sdkFactory_customField(args),
        customFieldSuggestion: wixMembersV1CustomFieldSuggestion_sdkFactory_customFieldSuggestion(args),
        memberRoleDefinition: wixMembersV1MemberRoleDefinition_sdkFactory_memberRoleDefinition(args),
        memberToMemberBlock: wixMembersV1MemberToMemberBlock_sdkFactory_memberToMemberBlock(args),
    };
}
//# sourceMappingURL=index.frontend.js.map